import Cookies from 'js-cookie';
import queryString from 'query-string';
import * as model from 'models';

//import { Auth } from 'aws-amplify';
// import { Auth } from './Auth';

// import { getStore } from 'store';

import config from './customWindow'
import { GenericSearchWrapper, InvoiceSearchRequest, SupplierInvoice, SupplierInvoiceImageResponse } from 'models/supplierinvoice';

export const API_URL = config.apiUrl;

class MyError extends Error {
  constructor(message: string) {
    super(message);
  }
  status: number;
  data: any;
}

export const postDataAsJson = async (endpoint: string, model : object
) => {
  const init = {
    method: "POST",
    body: JSON.stringify(model),
  };
  return fetchData(endpoint, {}, init);
}

export const fetchData = async (
  endpoint: string,
  queryParams = {},
  init: RequestInit | undefined = {},
  throwOnError = true,
  addDefaultContentType = true,
  apiURL = API_URL
) => {
  const baseInitArgs = {
    headers: {},
    method: 'GET'
  };

  const qsStr = queryString.stringify(queryParams) || '';

  endpoint = `${endpoint}${qsStr && '?'}${qsStr}`;

  // if (!auth && (fakeAuth.authInfo != null)) {
  //   auth = fakeAuth.authInfo;
  // };
  // const session = await Auth.currentSession();
  // console.log('using auth', session);
  // const jwtToken = await Auth.getValidJwtToken();

  // const customer = getStore().getState().customer.customer;
  // console.log('customer', customer);
  const xsrfTokenValue = Cookies.get('XSRF-TOKEN');

  Object.assign(
    baseInitArgs.headers,
    addDefaultContentType && { 'Content-type': 'application/json' },
    // session && {
    //   //Authorization: 'Bearer ' + session.getIdToken().getJwtToken()
    // },
    // jwtToken && {
    //   Authorization: 'Bearer ' + jwtToken,
    // },
    // customer && { customerId: customer.id }
    xsrfTokenValue && { "X-XSRF-TOKEN": xsrfTokenValue }
  );

  const finalInit = {
    ...baseInitArgs,
    ...init
  };

  return fetch(apiURL + endpoint, finalInit).then(response => {
    var contentType = response.headers.get('content-type');
    const isJson = contentType && contentType.includes('application/json');

    if (throwOnError && !response.ok) {
      if (isJson) {
        return response.text().then(value => {
          const deserializedError = deserialize(value);
          
          //const error = new MyError("Error");
          let error = {message: deserializedError?.responseStatus?.message ?? "Error",status : response.status, data: deserializedError};
          console.log("fetchData() error=", error);
          throw error;
        });
      }
      //var error = Error(response.statusText);
      //error.status = response.status;
      throw response;
    }

    if (isJson) {
      return response.text().then(value => {
        return deserialize(value);
      }).catch((e: any) => {
        console.log(e)
      });
    // } else {
    //   return {"error": "true"};
    }
  });
};

function deserialize(data: string): any {
  return JSON.parse(data, parseJson);
}

const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|(\+|-)([\d|:]*))?$/;
const reMsAjax = /^\/Date\((d|-|.*)\)[/|\\]$/;

function dateParser(key: any, value: any) {
  if (typeof value === 'string') {
    var a = reISO.exec(value);
    if (a) return new Date(value);
    a = reMsAjax.exec(value);
    if (a) {
      var b = a[1].split(/[-+,.]/);
      return new Date(b[0] ? +b[0] : 0 - +b[1]);
    }
  }
  return value;
}

function toCamelCase(key: any, value: any) {
  if (value && typeof value === 'object') {
    for (var k in value) {
      if (/^[A-Z]/.test(k) && Object.hasOwnProperty.call(value, k)) {
        value[k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
        delete value[k];
      }
    }
  }
  return value;
}

// First convert PascalCase to camelCase, then convert dates to JS dates
function parseJson(key: any, value: any) {
  value = toCamelCase(key, value)
  value = dateParser(key, value);
  return value;
}

const ControllerSupplierInvoice = `supplierinvoice`;
export async function supplierInvoiceAttachedFilesList(invoiceId: string): Promise<
  model.AttachedFileDto[]
> {
  const url = `${ControllerSupplierInvoice}/${invoiceId}/attachedfiles`;
  const response = await fetchData(url);
  return response;
}

export function supplierInvoiceAttachedFilesGet(invoiceId: string, fileId: string, inline: boolean = false): string {
  const url = `${API_URL}${ControllerSupplierInvoice}/${invoiceId}/attachedfiles/${fileId}?inline=${inline ? "true" : "false"}`;
  return url;
}

export async function supplierInvoiceAttachedFilesPost(invoiceId: string, files: File[]): Promise<model.SupplierInvoiceAttachedFilesPostSingleResponse> {
  const url = `${ControllerSupplierInvoice}/${invoiceId}/attachedfiles.json`;

  var data = new FormData()

  for (let i = 0; i < files.length; i++) {
    data.append('files[]', files[i]);
  }

  const response = await fetchData(url, undefined, {
    method: 'POST',
    body: data,
    headers: {
      "X-XSRF-TOKEN": Cookies.get('XSRF-TOKEN'),
      "Accept": "application/json"
    }
  }, true, false);
  return response;
}

export async function supplierInvoiceAttachedFilesDelete(invoiceId: string, fileId: string): Promise<model.SupplierInvoiceAttachedFilesDeleteResponse> {
  const url = `${ControllerSupplierInvoice}/${invoiceId}/attachedfiles/${fileId}`;

  const response = await fetchData(url, undefined, {
    method: 'DELETE',
  }, true, true);
  return response;
}

export async function supplierInvoiceSearch(search: InvoiceSearchRequest): Promise<
GenericSearchWrapper<SupplierInvoice>
> {
  const url = `${ControllerSupplierInvoice}`;
  const response = await fetchData(url, search);
  return response;
}

// http://localhost:53533/Data/LevFaktura/FakturaBild.aspx?fId=1175&pageNum=0&width=1220&height=1260&imageMode=0
export function supplierInvoiceImageGetUrl(invoiceId: string, pageNum?: number): string {
  const url = `${API_URL}../Data/LevFaktura/FakturaBild.aspx?fId=${invoiceId}&pageNum=${pageNum}&width=1220&height=1260&imageMode=0`;
  return url;
}

export async function supplierInvoiceImageGet(invoiceId: number): Promise<SupplierInvoiceImageResponse>
{
  const url = `${ControllerSupplierInvoice}/${invoiceId}/imageMetadata`;
  const response = await fetchData(url);
  return response;
}

export async function webSessionUpdate(cmd?: model.SessionUpdateCmd) : Promise<void> {
  const url = `../websessionupdatehandler.ashx`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(cmd),
  });
  return response;
}

const ControllerClient = `client`;
export async function userList(): Promise<model.UserDto[]> 
{
  const url = `${ControllerClient}/${config.klientId}/user`;
  const search = {};
  const response = await fetchData(url, search);
  return response;
}

export async function userGroupList(): Promise<model.UserGroupWithDetailsDto[]> 
{
  const url = `${ControllerClient}/${config.klientId}/usergroup`;
  const search = {};
  const response = await fetchData(url, search);
  return response;
}

export async function clientGet(clientId?: number): Promise<model.ClientLocal> 
{
  const url = `${ControllerClient}/${clientId ?? config.klientId}`;
  const search = {};
  const response = await fetchData(url, search);
  return response;
}

const ControllerUser = `user`;
export async function userGetCurrent(): Promise<model.UserDto> 
{
  const url = `${ControllerUser}/current`;
  const search = {};
  const response = await fetchData(url, search);
  return response;
}

const ControllerInstanceAdmin = `instanceadmin`;
export async function instanceAdminUserListRequest(): Promise<model.UserDto[] | null> 
{
  const url = `${ControllerInstanceAdmin}/users`;
  const search = {};
  const response = await fetchData(url, search);
  return response;
}
